import React, { useState, useEffect } from 'react';
import Header from '../shared/Header';
import paz from '../assets/imgs/paz.png'

import instagram from '../assets/icns/instagram-icn.svg';
import linkedin from '../assets/icns/linkedin-icn.svg';
import behance from '../assets/icns/behance-icn.svg';

const ContactPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []); 

  return (
  
    <div className='container-fluid bg-light'>
      <div className="row mt-sm-4 mb-5">
        <div className='header-height mt-5'></div>
          <div className='col-sm-2 col-xs-12'></div>
            <div className='col-sm col-xs-12'>
              
              <div className='row h-50 d-flex align-items-start pb-5 px-5'>
                <div className='col-lg-6 col-sm-12 col-xs-12 p-4 align-self-start'>
                  <h1 className='fw-normal lh-1 text-capitalize'>Let's work together</h1>
                    </div>

                  <div className='col-md col-xs-12 p-4 align-self-end'>
                    <p className='fs-4 fw-light lh-sm'>
                      Have a project in mind? I’d love to hear more about it. Feel free to reach out via the email or social media links below.
                      <br></br>
                      <span className='fw-bolder'>hey@pazroth.com</span>
                    </p>
                    <div className="float-end d-inline-flex align-items-baseline gap-3 mt-4">
                      <a href="https://www.instagram.com/paz_roth91/" className="social-icon"><img src={instagram} style={{ width: "25px" }} /></a>
                      <a href="https://www.linkedin.com/in/pazroth/" className="social-icon"><img src={linkedin} style={{ width: "25px" }} /></a>
                      <a href="https://www.behance.net/pazroth" className="social-icon"><img src={behance} style={{ width: "25px" }} /></a>
                    </div>


                </div>
              </div>

              <div className='bg-contact row h-50 d-flex align-items-start p-5'>
                <div className='col-12 p-4 align-self-center px-5'>
                  <h3 className='fw-normal lh-sm text-light'>
                  Partner with me to bring your brand's stories and strengths to life through art, design, and technology.
                  </h3>
                </div>
              </div>

            </div>
          </div>
        </div>



  );
};

export default ContactPage;


